<template>
  <div class="q-container q-pb-2 q-col-12 q-col-sm-6 q-col-md-3 q-d-block q-d-md-none q-pb-3 q-px-3 q-pb-sm-0">
    <button v-if="hasSelectedFilters" type="button"
            class="mobile-filters--clear-button q-btn q-btn q-w-100 q-btn-outline-danger q-mb-1"
            @click="filtersStore.clearSelectedFilters">
      {{ SmartSearchTranslations.filters.clear }}
    </button>
  </div>
</template>
<script setup lang="ts">
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {toRefs, inject} from "vue";


const filtersStore = useFiltersStore()
const {hasSelectedFilters} = toRefs(filtersStore)
import {SmartSearchTranslationsInterface} from "@/core/types";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

</script>
<style>

</style>